module.exports = __webpack_public_path__ + "img/plus_circle_sm.f3b5cf36.svg";